// extracted by mini-css-extract-plugin
export var headRow = "index-module--headRow--C0jbE";